var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessfulCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkmark-circle",
    d: "M155.068,1161.675a2.5,2.5,0,0,0-3.415.9l-15.987,27.7-8.945-8.25a2.5,2.5,0,0,0-3.65,3.425L134.5,1196a2.5,2.5,0,0,0,3.533.1c.3-.275,17.95-31.025,17.95-31.025a2.485,2.485,0,0,0-.915-3.4ZM140,1214a35,35,0,1,1,35-35,35,35,0,0,1-35,35Zm0-75a40,40,0,1,0,40,40,40,40,0,0,0-40-40Z",
    transform: "translate(-100 -1139)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulCircle);
export default __webpack_public_path__ + "static/media/successful-circle.e4ff71a8c72d79832b25b69e6e79143a.svg";
export { ForwardRef as ReactComponent };